import { Tooltip, TooltipVariant, type TooltipProps } from 'app/components/core/AccessibleTooltip';
import { FieldError, FieldWarning } from 'app/components/core/FieldError';

export interface ErrorTooltipProps extends Omit<TooltipProps, 'variant' | 'children'> {
    error?: string | string[];
    warning?: string | string[];
}

export function ErrorTooltip({ error, warning, ...props }: ErrorTooltipProps) {
    const hasError = Boolean(error?.length);
    const hasWarning = !hasError && Boolean(warning?.length);

    const variant = hasError
        ? TooltipVariant.ERROR
        : hasWarning
          ? TooltipVariant.WARNING
          : TooltipVariant.DEFAULT;

    return (
        <Tooltip variant={variant} {...props}>
            {variant === TooltipVariant.ERROR ? (
                <FieldError messages={error} />
            ) : variant === TooltipVariant.WARNING ? (
                <FieldWarning messages={warning} />
            ) : null}
        </Tooltip>
    );
}
